<!--header-right-->
<template>
  <div class="home-welcome-card">
    <img
        :style="{height: approvalList && approvalList.length > 0 ? '110px' : '94px'}"
        :src="getTheme('home:welcome:bg') || require('@/assets/image/home/home_welcome_bg.png')" alt="">
    <div class="welcome-info">
      <div class="left">
        <div class="title" :style="{color: getTheme('home:welcome:color')}">{{$t('Welcome')}}</div>
        <div class="text" :style="{color: getTheme('home:welcome:sub-color')}">
          {{PersonalInfor && PersonalInfor.UserInfo && PersonalInfor.UserInfo.CompanyName ? PersonalInfor.UserInfo.CompanyName : ''}}
        </div>
      </div>
      <div class="right" v-if="hasPower('因公:出差申请单')">
        <div class="icon" @click="_gotoTravelApply">
          <span :style="{backgroundImage: `url(${require('@/assets/image/base/add/icons_24pt_add.svg')})`}"></span>
        </div>
        <span :style="{color: getTheme('home:welcome:sub-color')}">{{$t('ApplyTravel')}}</span>
      </div>
    </div>
    <div class="my-swipe-box" v-if="approvalList && approvalList.length > 0" >
      <div class="icon-message">
        <div :style="{backgroundImage: `url(${require('@/assets/image/home/icons_32pt_notifaction@3x.png')})`}"></div>
      </div>
      <van-swipe class="my-swipe" style="height: 64px" autoplay="3000" vertical :show-indicators="false">
        <van-swipe-item v-for="(item, index) in approvalList" :key="`${index}${item.Id}`">
          <div class="approve-info">
            <div class="approve-info-left">
              <div class="approve-content">
                <div>{{item.Title}}</div>
                <span>{{_getShowTime(item.CreateTime)}}</span>
              </div>
            </div>
            <hs-button class="approve-btn" type="light-theme" height="28px" :fontSize="null" @click="_gotoDetails(item)">{{$t('GoApprovals')}}</hs-button>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import HsButton from "@/base/hs-button/hs-button.vue";
import {mapState} from "vuex"
import {
  PLANE_ORDER, CHANGE_PLANE_ORDER, HOTEL_ORDER, INTL_PLANE_ORDER, INTL_HOTEL_ORDER,
  TRAIN_ORDER, REFUND_PLANE_ORDER, REFUND_INTL_PLANE_ORDER, APPLY_FORM, BUS_ORDER
} from "common/constants/common.js"
import {getRoutePath, hotelRoutePush, planeRoutePush, trainRoutePush} from "@/common/utility/utils";
export default {
  props: {
    approvalList: {
      type: Array,
      default: () => {
        return []
      }
    },
    backgroundImage: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState([
      'PersonalInfor'
    ]),
  },
  methods: {
    _getShowTime(date) {
      if (!date) {
        return ''
      }
      let today = new Date().getTime()
      let dataNumber = this.beTimeDateNumber(date)
      let twoHours = 2 * 60 * 60
      let oneDay = 24 * 60 * 60
      let threeDays = 3 * 24 * 60 * 60
      let IntervalTime = (today - dataNumber) / 1000
      if (IntervalTime <= twoHours) {
        return this.$t('JustTime')
      } else if ( IntervalTime <= oneDay) {
        return this.beTime(date, "hh:mm")
      } else if (IntervalTime <= threeDays) {
        return this.beTime(date, "MM-dd hh:mm")
      } else {
        return date
      }
    },

    // 跳转出差申请单
    _gotoTravelApply() {
      this.$router.push('/travelApply/bookDetails')
    },

    /** 跳转对应的详情页面 */
    _gotoDetails(item) {
      let params = {
        isOwner: false,
        isExamine: true,
        QuerySource: 0,
        back: 1
      }
      if (item.OrderBusinessType === PLANE_ORDER || item.OrderBusinessType === CHANGE_PLANE_ORDER) {
        planeRoutePush({path: '/planeTicket/orderDetails', query: {Id: item.Id, ...params, back: 1}})
      } else if (item.OrderBusinessType === HOTEL_ORDER) {
        hotelRoutePush(getRoutePath({path: '/hotel/hotelOrder', query: {OrderID: item.Id, ...params, back: 1}}))
      } else if (item.OrderBusinessType === INTL_PLANE_ORDER) {
        planeRoutePush({path: '/intlPlaneTicket/orderDetails', query: {ID: item.Id, ...params, back: 1}})
      } else if (item.OrderBusinessType === INTL_HOTEL_ORDER) {
        hotelRoutePush(getRoutePath({path: '/intlHotel/hotelOrder', query: {OrderID: item.Id, ...params, back: 1}}))
      } else if (item.OrderBusinessType === TRAIN_ORDER) {
        trainRoutePush({path: '/train/orderDetail', query: {Id: item.Id, ...params, back: 1}})
      } else if (item.OrderBusinessType === REFUND_PLANE_ORDER) {
        planeRoutePush({path: '/planeTicket/refundDetails', query: {Id: item.Id, TravelType: 0, ...params, back: 1}})
      } else if (item.OrderBusinessType === REFUND_INTL_PLANE_ORDER) { // 国际机票
        planeRoutePush({path: '/intlPlaneTicket/refundDetails', query: {Id: item.Id, ...params, back: 1}})
      } else if (item.OrderBusinessType === APPLY_FORM) { // 出差申请单审批
        this.$router.push({path: '/personal/authOrderDetails', query: {Code: item.Id, ...params}})
      } else if (item.OrderBusinessType === BUS_ORDER) { // 出差申请单审批
        this.$router.push({path: '/bus/orderDetails', query: { OrderNo: item.Id, ...params}})
      }
    },
  },
  components: {
    HsButton
  },
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
/** 超标支付样式  */
.home-welcome-card
  width 100%
  min-height 94px
  border-radius 12px
  max-height 158px
  border 1px solid $color_black_0
  margin-bottom 12px
  background-size 100% auto
  background-repeat no-repeat
  position relative
  overflow hidden
  >img
    position absolute
    top 0
    left 0
    width 100%
    height 94px
    object-fit cover
    object-position center center
  >.welcome-info
    @extend .flex-between
    width 100%
    min-height 94px
    padding 11px 11px 12px 11px
    position relative
    >.left
      >.title
        ellipsis(1)
        @extend .hs-font-title-small
        color $color_black_900
        margin-bottom 4px
      >.text
        @extend .hs-font-body
        ellipsis(1)
        color rgba(41, 26, 27, 0.4)
    >.right
      display flex
      flex-direction column
      align-items center
      >.icon
        @extend .flex-center
        width 48px
        height 48px
        border-radius 8px
        margin-bottom 4px
        backdrop-filter blur(3px)
        background linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.3) 100%)
        >span
          width 24px
          height 24px
          background-repeat no-repeat
          background-size 24px 24px
          background-position center
      >span
        @extend .hs-font-overline-1
        color rgba(41, 26, 27, 0.4)
        text-align center
  >.my-swipe-box
    @extend .flex-start
    background-color $color_black_0
    border-radius 12px
    padding 0 12px
    position relative
    >.icon-message
      @extend .flex-center
      flex-shrink 0
      width 32px
      height 32px
      background linear-gradient(138.74deg, #FFA572 8.44%, #F0182A 92.39%)
      border-radius 8px
      margin-right 8px
      >div
        width 100%
        height 100%
        background-repeat no-repeat
        background-size 100% 100%
        background-position center
    >.my-swipe
      width 100%
  .approve-info
    @extend .flex-between
    width 100%
    min-height 64px
    >.approve-info-left
      @extend .flex-between
      >.approve-content
        @extend .hs-font-body
        color $color_black_800
        >div
          ellipsis(1)
        >span
          @extend .flex-start
          @extend .hs-font-caption-1
          color $color_black_100
    >.approve-btn
      min-width 60px
      margin-left 12px
      flex-shrink 0
</style>
